<h3 *ngIf="tableControl?.value?.label" class="table-title">{{tableControl.value.label}}</h3>
<div class="content-wrapper" [class.edit-mode]="editMode" [class.no-borders]="tableControl?.value?.showBorders === false">
    <ng-container *ngIf="!isUnset; else unsetTable">
    <table class="content" [ngSwitch]="tableControl.value.type">

        <ng-container *ngSwitchCase="'STATIC'">
            <ng-container *ngFor="let group of tableControl.value.groups; let i = index;">
                <tr class="table-row" [class.zebra]="i > 0 && i % 2 === 0">
                    <ng-container *ngFor="let entry of group.entries;">
                        <td class="table-cell"
                            [class.header]="i == 0"
                            [class.top]="entry.verticalAlign == 'top'"
                            [class.middle]="entry.verticalAlign == 'middle'"
                            [class.bottom]="entry.verticalAlign == 'bottom'"
                            [class.left]="entry.horizontalAlign == 'left'"
                            [class.center]="entry.horizontalAlign == 'center'"
                            [class.right]="entry.horizontalAlign == 'right'">
                            {{ entry.content }}
                        </td>
                    </ng-container>
                </tr>
            </ng-container>
        </ng-container>

        <ng-container *ngSwitchCase="'DYNAMIC'">
            <table mat-table class="dynamic-table" [dataSource]="compiledData?.rows" *ngIf="compiledData?.rows; else noData">

                <ng-container matColumnDef="ref">
                    <th mat-header-cell *matHeaderCellDef style="width: 10px;"></th>
                    <td mat-cell *matCellDef="let object; let i = index;">
                        <div class="table-data"
                            [style.backgroundColor]="compiledData.meta[i]?.colour"
                            [matTooltip]="(compiledData.meta[i]) | descTableRow:tableControl?.value?.context"
                            [matTooltipClass]="'mat-tooltip-custom reporting'">
                        </div>
                    </td>
                </ng-container>

                <ng-container *ngFor="let column of compiledData.columns" matColumnDef="{{ column.id }}">
                    <th mat-header-cell
                        *matHeaderCellDef
                        [class.left]="tableControl?.value?.config?.horizontalAlign == 'left'"
                        [class.center]="tableControl?.value?.config?.horizontalAlign == 'center'"
                        [class.right]="tableControl?.value?.config?.horizontalAlign == 'right'"
                    >
                        {{ column.itemDef?.label || null }}

                        <ng-container *ngIf="column.itemDef?.unit as unit">
                            [{{ 0 | convertValue:unit:tableControl.value?.system:'1.1-2':false }}]
                        </ng-container>
                    </th>

                    <td mat-cell *matCellDef="let object;"
                        [class.top]="tableControl?.value?.config?.verticalAlign == 'top'"
                        [class.middle]="tableControl?.value?.config?.verticalAlign == 'middle'"
                        [class.bottom]="tableControl?.value?.config?.verticalAlign == 'bottom'"
                        [class.left]="tableControl?.value?.config?.horizontalAlign == 'left'"
                        [class.center]="tableControl?.value?.config?.horizontalAlign == 'center'"
                        [class.right]="tableControl?.value?.config?.horizontalAlign == 'right'"
                    >
                        <ng-container [ngSwitch]="column.type">
                            <!-- CHARS -->
                            <ng-container *ngSwitchCase="'CHARACTERISTIC'">
                                <div class="table-data" [style.backgroundColor]="object[column.id]" *ngIf="column.itemDef?.type === 'color' && object[column.id]"></div>
                                {{ object[column.id] | labelCharValue:column.itemDef?.id : object[column.id+'.rescaled'] : true : true }}
                            </ng-container>
                            <!-- CHARS -->

                            <!-- PROPERTY -->
                            <ng-container *ngSwitchCase="'PROPERTY'">
                                {{ object[column.id] }}
                            </ng-container>
                            <!-- PROPERTY -->

                            <ng-container *ngSwitchDefault>
                                {{ object[column.id] | convertValue:column.itemDef?.unit:tableControl.value?.system:'1.1-2' }}
                            </ng-container>
                        </ng-container>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="compiledData.cols sticky: false"></tr>
                <tr mat-row *matRowDef="let row; columns: compiledData.cols; let i = index;" [class.zebra]="i % 2 === 1"></tr>
            </table>
            <ng-template #noData>
                <!-- TODO ADD NO DATA TEMPLATE -->
            </ng-template>
        </ng-container>
    </table>
    </ng-container>
    <ng-template #unsetTable>
        <div *ngIf="editMode" class="component-placeholder">
            <mat-icon class="material-symbols-outlined placeholder-icon">table_view</mat-icon>
            <span class="placeholder-title">Data Table</span>
            <span class="placeholder-hint">Open the menu to select columns and configure the table</span>
        </div>
    </ng-template>

    <div *ngIf="editMode" class="content-options no-print">
        <button
            mat-icon-button
            matTooltip="Item Actions"
            [matMenuTriggerFor]="optionMenu"
        >
            <mat-icon>more_vert</mat-icon>
        </button>
    </div>
</div>

<mat-menu #optionMenu>
    <ng-template matMenuContent>
        <button mat-menu-item (click)="edit()">
            <mat-icon>edit</mat-icon>
            <span>Edit Item </span>
        </button>

        <button mat-menu-item (click)="remove()">
            <mat-icon>delete</mat-icon>
            <span>Delete Item</span>
        </button>

        <!-- Duplicate temporarily hidden
        <button mat-menu-item (click)="makeDuplicate()">
            <mat-icon>content_copy</mat-icon>
            <span>Duplicate</span>
        </button>
        -->

        <button mat-menu-item (click)="editTypography.emit()">
            <mat-icon class="material-symbols-outlined">text_fields</mat-icon>
            <span>Font</span>
        </button>

        <button mat-menu-item [matMenuTriggerFor]="layering">
            <mat-icon class="material-symbols-outlined">
                stack
            </mat-icon>
            <span>Layering ({{ layerIndex }})</span>
        </button>
    </ng-template>
</mat-menu>

<!-- LAYERING -->
<mat-menu #layering="matMenu">
    <button mat-menu-item (click)="moveToTop()">
        <mat-icon class="material-symbols-outlined">
            arrow_shape_up_stack
        </mat-icon>
        <span>Send to Top</span>
    </button>
    <button mat-menu-item (click)="moveForward()">
        <mat-icon class="material-symbols-outlined">
            arrow_shape_up
        </mat-icon>
        <span>Move Forward</span>
    </button>
    <button mat-menu-item (click)="moveDown()">
        <mat-icon class="material-symbols-outlined flipped-icon">
            arrow_shape_up
        </mat-icon>
        <span>Move Down</span>
    </button>
    <button mat-menu-item (click)="moveToBottom()">
        <mat-icon class="material-symbols-outlined flipped-icon">
            arrow_shape_up_stack
        </mat-icon>
        <span>Send to Back</span>
    </button>
</mat-menu>
